import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { getEndpoint } from 'src/app/core/services/functions.service';

export interface AjusteValor {
  id?: number;
  c_emp: string;
  periodo: string;
  concepto: string;
  c_ven: string;
  valor: number;
  fecha_creacion?: string;
  usuario_creacion?: string;
  fecha_modificacion?: string;
  usuario_modificacion?: string;
}

export interface ApiResponse<T> {
  status: string;
  message: string;
  data: T;
}

@Injectable({
  providedIn: 'root'
})
export class AjusteValoresService {
  //private apiUrl = 'http://127.0.0.1:8000/ajuste-valor';
  ENDPOINT = getEndpoint('coms_ajuste_valor');

  constructor(private http: HttpClient) { }

  getAjustes(company: string): Observable<ApiResponse<AjusteValor[]>> {
    return this.http.get<any>(`${this.ENDPOINT}/`, { headers: { 'company': company } }).pipe(
      map(response => {
        // Si la respuesta ya tiene el formato ApiResponse, retornarla como está
        if (response && response.hasOwnProperty('data')) {
          return response;
        }
        // Si la respuesta es un array directo, convertirlo al formato ApiResponse
        return {
          status: 'success',
          message: 'Ajustes recuperados exitosamente',
          data: Array.isArray(response) ? response : []
        };
      }),
      catchError(error => {
        throw error;
      })
    );
  }

  createAjuste(ajuste: AjusteValor, company: string): Observable<ApiResponse<AjusteValor>> {
    return this.http.post<any>(`${this.ENDPOINT}/`, ajuste , { 
      headers: { 'company': company } 
    }).pipe(
      map(response => {
        if (response && response.hasOwnProperty('data')) {
          return response;
        }
        return {
          status: 'success',
          message: 'Ajuste creado exitosamente',
          data: response
        };
      })
    );
  }

  updateAjuste(id: number, ajuste: AjusteValor, company: string): Observable<ApiResponse<AjusteValor>> {
    return this.http.put<any>(`${this.ENDPOINT}/${id}/`, ajuste, { headers: { 'company': company } }).pipe(
      map(response => {
        if (response && response.hasOwnProperty('data')) {
          return response;
        }
        return {
          status: 'success',
          message: 'Ajuste actualizado exitosamente',
          data: response
        };
      }),
      catchError(error => {
        throw error;
      })
    );
  }

  deleteAjuste(id: number, company: string): Observable<ApiResponse<void>> {
    return this.http.delete<any>(`${this.ENDPOINT}/${id}/`, { headers: { 'company': company } }).pipe(
      map(response => {
        if (response && response.hasOwnProperty('data')) {
          return response;
        }
        return {
          status: 'success',
          message: 'Ajuste eliminado exitosamente',
          data: response
        };
      })
    );
  }
}
